import React from 'react'
import PropTypes from 'prop-types';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Paper, Typography, TextField, Icon, IconButton, LinearProgress, CircularProgress, Switch, FormControlLabel, AppBar, Toolbar, Tabs, Tab } from '@material-ui/core'
import { RadioGroup, Radio, ButtonGroup, Button, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Zoom } from '@material-ui/core';
import IconSearch from '@material-ui/icons/Search'
import IconClearAll from '@material-ui/icons/ClearAll'
import IconBilingual from '@material-ui/icons/Translate'
import IconMonolingual from '@material-ui/icons/Title'
import IconList from '@material-ui/icons/List'
import IconAdd from '@material-ui/icons/Add'
import IconMoreVert from '@material-ui/icons/MoreVert'
import IconCloudDownload from '@material-ui/icons/CloudDownload'
import MUIDataTable from "mui-datatables";
import CurtainWithProgress from '../../components/CurtainWithProgress'
import ParallelTextTable from '../../components/ParallelTextTable'
import MonoTextTable from '../../components/MonoTextTable'
import SearchScopeSelectionBox from '../../components/SearchScopeSelectionBox'
import SearchModeSelection from '../../components/SearchModeSelection'
import Header from '../../components/Header'
import Highlighter from "react-highlight-words";
import { yellow, blue } from '@material-ui/core/colors'
import { connect } from 'react-redux'
import {
  searchBilingual,
  searchMonolingual,
  getParallelText,
  getMonoText,
  resetSearch,
  getBookList
} from '../../modules/search'
import downloadAsExcel from '../../resources/downloadAsExcel'

const styles = theme => ({
  root: {
    // ...theme.mixins.gutters(),
    minHeight: '100vh',
    // margin: theme.spacing.unit * 2,
    // padding: theme.spacing.unit * 2,
    // paddingTop: theme.spacing.unit * 2,
    // paddingBottom: theme.spacing.unit * 2,
  },
  searchInput: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
    width: 64,
    height: 64,
    padding: 16
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  searchModeRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    width: 32,
    height: 32
  },
  highlight: {
    backgroundColor: yellow['200'],
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: blue['800'],
    }
  },
  messageContainer: {
    margin: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 3
  },
  linearProgressBar: {
    width: 20
  },
  grow: {
    flexGrow: 1,
  },
  resultCircularProgress: {
    width: 5
  },
  featureBar: {
    display: 'flex'
  },
  pointerCursor: {
    cursor: 'pointer'
  },
  corpusSelectionRadioGroup: {
    border: 'solid 1px',
    borderColor: blue['200'],
    borderRadius: 3,
    marginLeft: 10,
    marginRight: 10,
    width: 'auto',
    height: 'auto',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
  },
  nowrap: {
    whiteSpace: 'nowrap'
  },
  selectedMode: {
    marginLeft: 2,
    marginRight: 2,
    padding: 5,
    borderRadius: 3,
    backgroundColor: blue['100']
  },
  notSelectedMode: {
    marginLeft: 2,
    marginRight: 2,
    padding: 5,
    borderRadius: 3,
  },
  collocationButton: {
    margin: theme.spacing.unit,
    alignSelf: 'center'
  },
})

const TabContainer = (props) => <div>{props.children}</div>
const tableOptions = {
  rowsPerPageOptions: [10, 50, 100, 500, 1000, 5000],
  viewColumns: false,
  selectableRows: 'none',
  filter: false,
  elevation: 0,
  print: false,
  download: false
}

const initialState = {
  searchInput: '',
  searchError: '',
  corpusSelection: 'parallelOnly',
  searchMode: 'equalsto',
  currentResultTab: 0,
  showNoResultMessage: false,
  checkedList: null,
  showSearchResultsPinyin: false,
  gapFilling: false
}

const SearchInProgress = () => <CircularProgress color="secondary" disableShrink aria-busy={true} thickness={2} size={24}/>

const clickNote = 'Click the highlighted keyword to view nearby texts.'

const cleanFilename = (filename) => filename && filename.replace(/[\/\\ :=]/g, '_').replace(/_{2,}/g, '_')

const searchModeText = (mode) => mode === 'startswith' ? 'starting with' : mode === 'endswith' ? 'ending with' : mode === 'contains' ? 'containing' : 'equal to'

const Gap = ({text, search}) => {
  return (
    <div>
      {gapText(text, search)}
    </div>
  )
}

const gapText = (text, search, mode) => text.replace(new RegExp(search, 'ig'), '____')

const createSearchPattern = (language, query, searchMode) => language === 'en' ? (
        searchMode === 'startswith' ? '\\b' + query + '\\w*\\b':
        searchMode === 'endswith' ? '\\b\\w*' + query + '\\b' :
        searchMode === 'contains' ? '\\b\\w*' + query + '\\w*\\b':
        '\\b' + query + '\\b'
      ) : query && query.split('').map(c=>c + '[ ()a-z0-9]*').join('')

const collocationsHeading = ['Left-6','Left-5','Left-4','Left-3','Left-2','Left-1','Right-1','Right-2','Right-3','Right-4','Right-5','Right-6']

class Search extends React.Component {
  constructor () {
    super()
    this.state = initialState
  }

  componentDidMount() {
    this.props.getBookList()
    setTimeout( () => {
      this.searchInput && this.searchInput.focus()
    }, 500)
  }

  componentDidUpdate(prevProps, prevState) {
    const { classes, search } = this.props
    const { getBookListStarted, getBookListFailed, bookList,
      searchParallelStarted, searchParallelFailed, parallelSearchResults,
      searchMonoStarted, searchMonoFailed, monolingualSearchResults,
      getParallelTextStarted, getParallelTextFailed, parallelTextResults,
      getMonoTextStarted, getMonoTextFailed, monoTextResults } = search
    const { results: parallelSearchResultList } = parallelSearchResults || {}
    const { results: monoSearchResultList } = monolingualSearchResults || {}
    if (prevProps.search.searchParallelStarted && !searchParallelStarted && searchParallelFailed) {
      this.setState({
        searchError: this.props.search.searchParallelFailed
      })
    } else if (!prevProps.search.searchParallelStarted && searchParallelStarted) {
      this.setState({
        searchError: ''
      })
    } else if (prevProps.search.searchParallelStarted && !searchParallelStarted ||
      prevProps.search.searchMonoStarted && !searchMonoStarted) {
      this.setState({
        showParallelTab: this.state.corpusSelection === 'parallelOnly' || this.state.corpusSelection === 'both',
        showMonoTab: this.state.corpusSelection === 'monoOnly' || this.state.corpusSelection === 'both',
        // currentResultTab: this.state.searchParallelCorpusOnly ? 0 : this.state.currentResultTab,
        currentResultTab: this.state.corpusSelection === 'parallelOnly' || this.state.corpusSelection === 'both' ? 0 : 1,
        showNoResultMessage: (!parallelSearchResultList || parallelSearchResultList && parallelSearchResultList.length === 0) &&
          (!monoSearchResultList || monoSearchResultList && monoSearchResultList.length === 0)
      })
    }
    if (prevProps.search.getParallelTextStarted && !getParallelTextStarted && !getParallelTextFailed) {
      this.setState({
        showParallelTextSearchResults: true
      })
    }
    if (prevProps.search.getMonoTextStarted && !getMonoTextStarted && !getMonoTextFailed) {
      this.setState({
        showMonoTextSearchResults: true
      })
    }
  }

  getMuiTheme = () => createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {
        root: {
          '&:nth-child(1)': {
            width: '12%'
          },
          '&:nth-child(2)': {
            width: '44%'
          },
          '&:nth-child(3)': {
            width: '44%'
          }
        }
      },
      MUIDataTableBodyCell: {
        root: {
          padding: '10px'
        }
      }
    }
  })

  performSearchBilingual() {
    this.setState({
      showNoResultMessage: false,
      showSearchScopeSelection: false
    }, () => {
      if (this.state.searchInput) {
        if (this.state.corpusSelection === 'parallelOnly' || this.state.corpusSelection === 'both') {
          this.props.searchBilingual({
            query: this.state.searchInput,
            bookList: this.state.checkedList,
            mode: this.state.searchMode
          })
        }
        if (this.state.corpusSelection === 'monoOnly' || this.state.corpusSelection === 'both') {
          this.props.searchMonolingual({
            query: this.state.searchInput,
            bookList: this.state.checkedList,
            mode: this.state.searchMode
          })
        }
      } else {
        // console.debug('searchInput is empty')
      }
    })
  }

  // downloadAsExcel({columns, data, filename}) {
  //   const headings = columns && columns
  //     .filter(heading => typeof heading === 'string' || (heading.options && heading.options.download))
  //     .map(heading => typeof heading === 'string' ? heading : heading.name)
  //   // console.debug(`download as Excel clicked`)
  //   // console.debug(headings)
  //   // console.debug(data)
  //   let html = `<table><tbody>\n<tr><th>${headings && headings.join('</th><th>')}</th></tr>\n`
  //   html += data ? data.map(row => `<tr><td>${row.join('</td><td>')}</td></tr>`).join('\n') + '</tbody></table>\n' : ''
  //   toXlsx(html, filename || 'results')
  // }

  render() {
    const { classes, search } = this.props
    const { getBookListStarted, getBookListFailed, bookList,
      searchParallelStarted, searchParallelFailed, parallelSearchResults,
      searchMonoStarted, searchMonoFailed, monolingualSearchResults,
      getParallelTextStarted, getParallelTextFailed, parallelTextResults,
      getMonoTextStarted, getMonoTextFailed, monoTextResults } = search
    const { language, query, mode: parallelSearchMode, result_count: parallelResultCount, results: parallelSearchResultList, collocations: parallelCollocations } = parallelSearchResults || {}
    const { language: monoSearchLanguage, query: monoSearchQuery, mode: monoSearchMode, result_count: monoResultCount, results: monoSearchResultList, collocations: monoCollocations } = monolingualSearchResults || {}
    const { alignmentId: parallelTextAlignmentId, bookNames: parallelTextBookNames, language: parallelTextLanguage, resultList: parallelTextResultList } = parallelTextResults || {}
    const { sentenceId: monoTextSentenceId, bookName: monoTextBookName, language: monoTextLanguage, resultList: monoTextResultList } = monoTextResults || {}
    const { searchInput, searchError, searchParallelCorpusOnly, searchMode } = this.state
    const disabled = getBookListStarted || searchParallelStarted || searchMonoStarted || getParallelTextStarted || getMonoTextStarted
    const showCurtain = getBookListStarted || searchParallelStarted || searchMonoStarted || getParallelTextStarted || getMonoTextStarted
    const parallelColumns = language === 'en' ? ['Source', {
        name: 'English',
        options: {
          display: 'true',
          searchable: false,
          download: false
        }
      }, {
        name: 'English',
        options: {
          display: 'false',
          searchable: true,
          download: true
        }
      }, 'Chinese'] : ['Source', {
        name: 'Chinese',
        options: {
          display: 'true',
          searchable: false,
          download: false
        }
      }, {
        name: 'Chinese',
        options: {
          display: 'false',
          searchable: true,
          download: true
        }
      }, 'English']
    const monoColumns = monoSearchLanguage === 'en' ? ['Source', {
        name: 'English',
        options: {
          display: 'true',
          searchable: false,
          download: false
        }
      }, {
        name: 'English',
        options: {
          display: 'false',
          searchable: true,
          download: true
        }
      }] : ['Source', {
        name: 'Chinese',
        options: {
          display: 'true',
          searchable: false,
          download: false
        }
      }, {
        name: 'Chinese',
        options: {
          display: 'false',
          searchable: true,
          download: true
        }
      }]
    const replacePattern = createSearchPattern(language, query, parallelSearchMode)
    // console.debug(`replacePattern=${replacePattern}`)
    const data = language === 'en' ? parallelSearchResultList && parallelSearchResultList.map(data => [
      `${data.en_book_name} / ${data.cn_book_name}`,
      <div className={classes.pointerCursor} onClick={()=>{
        this.props.getParallelText({ alignmentId: data.id, language, bookNames: `${data.en_book_name} / ${data.cn_book_name}` })
      }}>
        {this.state.gapFilling ? <Gap text={data.en} search={replacePattern} /> :
          <Highlighter
            highlightClassName={classes.highlight}
            searchWords={[replacePattern]}
            autoEscape={false}
            textToHighlight={data.en}
          />
        }
      </div>,
      data.en,
      (this.state.showSearchResultsPinyin ? data.pinyin : data.cn) || '-'])
    : parallelSearchResultList && parallelSearchResultList.map(data => [
      `${data.cn_book_name} / ${data.en_book_name}`,
      <div className={classes.pointerCursor} onClick={()=>{
        this.props.getParallelText({ alignmentId: data.id, language, bookNames: `${data.cn_book_name} / ${data.en_book_name}` })
      }}>
        {this.state.gapFilling ? <Gap text={this.state.showSearchResultsPinyin ? data.pinyin : data.cn} search={replacePattern} /> :
          <Highlighter
          highlightClassName={classes.highlight}
          searchWords={[replacePattern]}
          autoEscape={false}
          textToHighlight={(this.state.showSearchResultsPinyin ? data.pinyin : data.cn) || '-'}
        />}
      </div>,
      (this.state.showSearchResultsPinyin ? data.pinyin : data.cn),
      data.en])
    // const monoReplacePattern = monoSearchLanguage === 'en' ? monoSearchQuery : monoSearchQuery && monoSearchQuery.split('').map(c=>c + '[ ()a-z0-9]*').join('')
    const monoReplacePattern = createSearchPattern(monoSearchLanguage, monoSearchQuery, monoSearchMode)
    // console.debug(`monoReplacePattern=${monoReplacePattern}`)
    const monoData = monoSearchLanguage === 'en' ? monoSearchResultList && monoSearchResultList.map(data => [
      data.book_name,
      <div className={classes.pointerCursor} onClick={()=>{
        // console.debug(`sentence id = ${data.sentence_id}, language = ${language}`)
        this.props.getMonoText({ sentenceId: data.sentence_id, language })
      }}>
        {this.state.gapFilling ? <Gap text={data.text} search={monoReplacePattern} /> :
          <Highlighter
            highlightClassName={classes.highlight}
            searchWords={[monoReplacePattern]}
            autoEscape={false}
            textToHighlight={data.text}
          />
        }
      </div>, data.text])
    : monoSearchResultList && monoSearchResultList.map(data => [
      data.book_name,
      <div className={classes.pointerCursor} onClick={()=>{
        // console.debug(`sentence id = ${data.sentence_id}, language = ${language}`)
        this.props.getMonoText({ sentenceId: data.sentence_id, language })
      }}>
        {this.state.gapFilling ? <Gap text={this.state.showSearchResultsPinyin ? data.pinyin : data.text} search={monoReplacePattern} /> :
          <Highlighter
            highlightClassName={classes.highlight}
            searchWords={[monoReplacePattern]}
            autoEscape={false}
            textToHighlight={this.state.showSearchResultsPinyin ? data.pinyin : data.text}
          />
        }
      </div>, this.state.showSearchResultsPinyin ? data.pinyin : data.text])
    const options = {
      ...tableOptions,
      customSearch: (searchQuery, currentRow, columns) => {
        const search = searchQuery && searchQuery.toLowerCase()
        const t1 = currentRow[2] && currentRow[2].toLowerCase()
        const t2 = currentRow[3] && currentRow[3].toLowerCase()
        const t3 = currentRow[4] && currentRow[4].toLowerCase()
        return !search || (t1 && t1.indexOf(search) >= 0) || (t2 && t2.indexOf(search) >= 0) || (t3 && t3.indexOf(search) >= 0)
      }
      // downloadOptions: {filename: 'results.txt', separator: '\t'}
    };
    const monoOptions = {
      ...tableOptions,
      customSearch: (searchQuery, currentRow, columns) => {
        const search = searchQuery && searchQuery.toLowerCase()
        const t1 = currentRow[2] && currentRow[2].toLowerCase()
        return !search || (t1 && t1.indexOf(search) >= 0)
      }
    };
    return (
      <Paper className={classes.root} elevation={1}>
        <Header/>
        <div className={classes.inputRow}>
          <TextField
            inputRef={(searchInput) => {
              this.searchInput = searchInput
            }}
            id="searchInput"
            label="Search"
            placeholder='Enter an English or Chinese term/phrase to search, e.g. "in fact", "一切", "ology"'
            helperText={searchError}
            error={!!searchError}
            className={classes.searchInput}
            value={searchInput}
            onChange={(evt) => this.setState({
              searchInput: evt.target.value,
              searchError: ''
            })}
            margin="normal"
            variant="outlined"
            fullWidth
            onKeyPress={(evt) => {
              if (evt.key === 'Enter') {
                this.performSearchBilingual()
                evt.preventDefault()
              }
            }}
            autoFocus
            disabled={disabled}
          />
          <IconButton color="primary" className={classes.button} aria-label="Search" onClick={()=>this.performSearchBilingual()} disabled={disabled}>
            <IconSearch className={classes.icon}/>
          </IconButton>
          {/*<FormControlLabel
            control={<Switch
              checked={searchParallelCorpusOnly}
              onChange={(evt) => {
                this.setState({
                  searchParallelCorpusOnly: evt.target.checked
                })
              }}
              value="Search Parallel Corpus Only"
              color="primary"
              inputProps={{ 'aria-label': 'Search Parallel Corpus Only Checkbox' }}
              disabled={disabled}
            />}
            label="Search Parallel Corpus Only"
          />*/}

          <RadioGroup
            aria-label="Search Parallel or Monolingual"
            value={this.state.corpusSelection}
            onChange={evt => this.setState({
              corpusSelection: evt.target.value
            })}
            className={classes.corpusSelectionRadioGroup}
            disabled={disabled}
          >
            <Tooltip title="Search Parallel Corpus Only">
              <FormControlLabel className={this.state.corpusSelection === 'parallelOnly' ? classes.selectedMode : classes.notSelectedMode} value="parallelOnly" control={<Radio />} label={<IconBilingual/>} />
            </Tooltip>
            <Tooltip title="Search Monolingual Corpus Only">
              <FormControlLabel className={this.state.corpusSelection === 'monoOnly' ? classes.selectedMode : classes.notSelectedMode} value="monoOnly" control={<Radio />} label={<IconMonolingual/>} />
            </Tooltip>
            <Tooltip title="Search Both Parallel and Monolingual Corpora">
              <FormControlLabel className={this.state.corpusSelection === 'both' ? classes.selectedMode : classes.notSelectedMode} value="both" control={<Radio />} label={<span className={classes.nowrap}><IconBilingual/><IconAdd/><IconMonolingual/></span>} />
            </Tooltip>
          </RadioGroup>

          {bookList && <Tooltip title="Change Search Scope">
            <IconButton color="primary" className={classes.button} aria-label="Select Search Scope" onClick={()=>this.setState({
              showSearchScopeSelection: !this.state.showSearchScopeSelection
            })} disabled={disabled}>
              <IconMoreVert className={classes.icon}/>
            </IconButton>
          </Tooltip>}
        </div>
        <div className={classes.searchModeRow}>
          <Typography variant='body1' style={{marginRight: 20}}>
            Match mode:
          </Typography>
          <SearchModeSelection
            value={this.state.searchMode}
            onChange={(value) => this.setState({
              searchMode: value
            })}
            disabled={disabled}
          />
          <Typography variant='caption' style={{marginLeft: 50}}>
            (Only applicable to single-word English search term)
          </Typography>
        </div>
        { this.state.showSearchScopeSelection && bookList && <Zoom in={this.state.showSearchScopeSelection}>
          <SearchScopeSelectionBox
            bookList={bookList}
            checkedList={this.state.checkedList}
            onChange={(checkedList) => this.setState({
              checkedList
            })}
          />
        </Zoom>}
        { showCurtain && <CurtainWithProgress show={showCurtain} />}
        { this.state.showParallelTextSearchResults && parallelTextResultList && <Dialog
          open={this.state.showParallelTextSearchResults}
          onClose={() => this.setState({
            showParallelTextSearchResults: false
          })}
          aria-labelledby="customized-dialog-title"
          aria-describedby="customized-dialog-description"
          fullWidth={true}
          maxWidth={'xl'}
        >
          <DialogTitle id="customized-dialog-title">{`Excerpt from \u201C${parallelTextBookNames}\u201D`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="customized-dialog-description">
              <ParallelTextTable
                data={parallelTextResultList.map(v => language === 'en' ? [v.alignment_id, v.en, (this.state.showSearchResultsPinyin ? v.pinyin : v.cn) || '-'] : [v.alignment_id, (this.state.showSearchResultsPinyin ? v.pinyin : v.cn) || '-', v.en])}
                language={language}
                highlightId={parallelTextAlignmentId}
                disabled={disabled}
                filename={cleanFilename(parallelTextBookNames)}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({
                showParallelTextSearchResults: false
              })} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>}
        { this.state.showMonoTextSearchResults && monoTextResultList && <Dialog
          open={this.state.showMonoTextSearchResults}
          onClose={() => this.setState({
            showMonoTextSearchResults: false
          })}
          aria-labelledby="customized-dialog-title"
          aria-describedby="customized-dialog-description"
          fullWidth={true}
          maxWidth={'xl'}
        >
          <DialogTitle id="customized-dialog-title">{`Excerpt from \u201C${monoTextBookName}\u201D`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="customized-dialog-description">
              <MonoTextTable
                data={monoTextResultList.map(v => monoTextLanguage === 'en' ? [v.sentenceId, v.text] : [v.sentenceId, (this.state.showSearchResultsPinyin ? v.pinyin : v.text)])}
                language={monoTextLanguage}
                highlightId={monoTextSentenceId}
                disabled={disabled}
                filename={cleanFilename(monoTextBookName)}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({
                showMonoTextSearchResults: false
              })} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>}
        { this.state.collocations && this.state.collocations.length > 0 && <Dialog
          open={!!this.state.collocations}
          onClose={() => this.setState({
            collocations: null
          })}
          aria-labelledby="customized-dialog-title"
          aria-describedby="customized-dialog-description"
          fullWidth={true}
          maxWidth={'xl'}
        >
          <DialogTitle id="customized-dialog-title">
            {this.state.currentResultTab === 0 ? `Collocations for \u201C${query}\u201D in Parallel Corpus` : `Collocations for \u201C${monoSearchQuery}\u201D in Monolingual Corpus`}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="customized-dialog-description">
              <MUIDataTable
                title={<div>
                  Download Collocations
                  <IconButton color="primary" className={classes.button} aria-label="Download as Excel" onClick={()=>
                    downloadAsExcel({
                      columns: collocationsHeading,
                      data: this.state.collocations.map(row => row.map(v => v ? `${v.key} (${v.frequency})` : '-')),
                      filename: `${this.state.currentResultTab === 0 ? 'parallel' : 'monolingual'}-collocations-${cleanFilename(searchInput)}.xls`
                    })} disabled={disabled}>
                    <IconCloudDownload className={classes.icon}/>
                  </IconButton>
                </div>}
                data={this.state.collocations.map(row => row.map(v => v ? `${v.key} (${v.frequency})` : '-'))}
                columns={collocationsHeading}
                options={{
                  rowsPerPage: 100,
                  rowsPerPageOptions: [100, 500],
                  viewColumns: false,
                  selectableRows: 'none',
                  filter: false,
                  elevation: 0,
                  print: false,
                  download: false,
                  search: true
                }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({
                collocations: null
              })} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>}
        {!searchParallelStarted && !searchMonoStarted && this.state.showNoResultMessage &&
          <div className={classes.messageContainer}>
            {`No results are found for \u201C${query}\u201D`}
          </div>}
        {(parallelSearchResultList && parallelSearchResultList.length > 0 ||
          monoSearchResultList && monoSearchResultList.length > 0
          ) && <div>
          <AppBar position="static" color="default">
          <Toolbar>
            <Tabs
              value={this.state.currentResultTab}
              onChange={(evt, value) => {
                this.setState({
                  currentResultTab: value
                })
              }}
            >
              {this.state.showParallelTab && <Tab icon={searchParallelStarted ? <SearchInProgress/> : <IconBilingual/>} label="PARALLEL"/>}
              {this.state.showMonoTab && <Tab icon={searchMonoStarted ? <SearchInProgress/> : <IconMonolingual/>} label="MONOLINGUAL"/>}
            </Tabs>
            <div className={classes.grow} />
            <div className={classes.featureBar} >
              <Tooltip title="Turn Gap Filling On/Off">
                <FormControlLabel
                  control={<Switch
                    checked={this.state.gapFilling}
                    onChange={(evt) => {
                      this.setState({
                        gapFilling: evt.target.checked
                      })
                    }}
                    value="Gap Filling"
                    color="primary"
                    inputProps={{ 'aria-label': 'Gap Filling' }}
                    disabled={disabled}
                  />}
                  label="Gap Filling"
                />
              </Tooltip>
              <Tooltip title="Show/Hide Pinyin">
                <FormControlLabel
                  control={<Switch
                    checked={this.state.showSearchResultsPinyin}
                    onChange={(evt) => {
                      this.setState({
                        showSearchResultsPinyin: evt.target.checked
                      })
                    }}
                    value="Show Pinyin"
                    color="primary"
                    inputProps={{ 'aria-label': 'Show Pinyin' }}
                    disabled={disabled}
                  />}
                  label="Show Pinyin"
                />
              </Tooltip>
              <Tooltip title="Inspect Collocations">
                <Button
                  color='secondary'
                  variant='contained'
                  size='small'
                  className={classes.collocationButton}
                  onClick={() => this.setState({
                    collocations: this.state.currentResultTab === 0 ? parallelCollocations : monoCollocations
                  })}
                  disabled={disabled || (parallelSearchMode && parallelSearchMode !== 'equalsto') || (monoSearchMode && monoSearchMode !== 'equalsto') || (language && language !== 'en') || (monoSearchLanguage && monoSearchLanguage !== 'en')}
                >
                  <IconList /> Collocations
                </Button>
              </Tooltip>
              <Tooltip title="Download as Excel">
                <IconButton color="primary" className={classes.button} aria-label="Download as Excel" onClick={()=>{
                  if (this.state.currentResultTab === 0) {
                    downloadAsExcel({
                      columns: parallelColumns,
                      data: data.map(row => [row[0], this.state.gapFilling ? gapText(row[2], replacePattern) : row[2], row[3]]),
                      filename: `parallel-results-${cleanFilename(searchInput)}.xls`
                    })
                  } else if (this.state.currentResultTab === 1) {
                    downloadAsExcel({
                      columns: monoColumns,
                      data: monoData.map(row => [row[0], this.state.gapFilling ? gapText(row[2], monoReplacePattern) : row[2]]),
                      filename: `monolingual-results-${cleanFilename(searchInput)}.xls`
                    })
                  }
                  
                }} disabled={disabled}>
                  <IconCloudDownload className={classes.icon}/>
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear Search Results">
                <IconButton className={classes.button} aria-label="Reset" color="primary" label="Clear" disabled={disabled} onClick={()=>{
                  this.props.resetSearch()
                  this.setState({
                    ...initialState,
                    checkedList: this.state.checkedList
                  })
                }}>
                  <IconClearAll className={classes.icon}/>
                </IconButton>
              </Tooltip>
            </div>
          </Toolbar>
          </AppBar>
          { this.state.currentResultTab === 0 && <TabContainer>
            {parallelSearchResultList && parallelSearchResultList.length > 0 ? <MuiThemeProvider theme={this.getMuiTheme()}>
              <MUIDataTable
                title={`${parallelResultCount} parallel result${parallelSearchResultList.length > 1 ? 's' : ''} found for search term (${searchModeText(parallelSearchMode)}) \u201C${query}\u201D.${parallelResultCount > parallelSearchResultList.length ? " First " + parallelSearchResultList.length + " results are retrieved." : ""} ${clickNote}`}
                data={data}
                columns={parallelColumns}
                options={options}
              />
            </MuiThemeProvider> : <div className={classes.messageContainer}>
              {searchParallelStarted ? `Searching. Please wait...` : `No parallel search results`}
            </div>}
          </TabContainer>}
          { this.state.currentResultTab === 1 && <TabContainer>
            {monoSearchResultList && monoSearchResultList.length > 0 ? <MuiThemeProvider theme={this.getMuiTheme()}>
              <MUIDataTable
                title={`${monoResultCount} monolingual result${monoSearchResultList.length > 1 ? 's' : ''} found for search term (${searchModeText(monoSearchMode)}) \u201C${monoSearchQuery}\u201D.${monoResultCount > monoSearchResultList.length ? " First " + monoSearchResultList.length + " results are retrieved." : ""}  ${clickNote}`}
                data={monoData}
                columns={monoColumns}
                options={monoOptions}
              />
            </MuiThemeProvider> : <div className={classes.messageContainer}>
              {searchMonoStarted ? `Searching. Please wait...` : `No monolingual search results`}
            </div>}
          </TabContainer>}
        </div>}

      </Paper>
    )
  }
}

const mapStateToProps = ({ search }) => ({
  search
})

// const mapDispatchToProps = dispatch =>
//   bindActionCreators(
//     {
//       markOn,
//       markOff,
//       increment,
//       incrementAsync,
//       decrement,
//       decrementAsync,
//       changePage: () => push('/about-us')
//     },
//     dispatch
//   )

const mapDispatchToProps = {
  searchBilingual,
  searchMonolingual,
  getParallelText,
  getMonoText,
  resetSearch,
  getBookList
}

Search.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Search))
